
import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material";
import { MatDialogRef} from '@angular/material';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
import {Questions} from "../classes/question";
import {Age} from "../classes/age";


@Component({
  selector: 'edit-age-dialog',
  templateUrl: './edit-age-dialog.component.html',
  styleUrls: ['edit-age-dialog.component.css']
})
export class EditAgeDialogComponent {

  dispValue : string;
  questions : Questions[];
  ageQuestions : Questions[];
  newAge : Age;
  parentStatement : string;
  parent :string = "";
  ageRange : string = "";
  childClass : string[] = [];


  constructor(@Inject(MAT_DIALOG_DATA) public data : any,public dialogRef: MatDialogRef<EditAgeDialogComponent>,private toastyService:ToastyService, private toastyConfig: ToastyConfig) {
    this.questions = data.questions;
    this.dispValue = data.dispValue;
    this.newAge = data.newAge;
    if(this.newAge.key.length > 0){
      this.parentStatement = this.questions[this.newAge.parent - 1].Qn_In + " "+this.questions[this.newAge.parent - 1].Qn;
      if(!this.ageQuestions){
        this.ageQuestions = [];
      }
      if(this.questions[this.newAge.parent - 1].Parent_Repeat){
        let i : number = this.newAge.parent;
        while(i < this.questions.length && this.questions[i].Parent_Repeat === this.questions[this.newAge.parent-1].Parent_Repeat){
          this.ageQuestions.push(this.questions[i]);
          i++;
        }
      }else{
        for(let i=this.newAge.parent;i<this.questions.length;i++){
          this.ageQuestions.push(this.questions[i]);
        }
      }

    }else{
      this.parentStatement = "Select a Question";
    }

  }

  ageParentSelected(parent : number){
    if(!this.newAge.parent ||  this.newAge.parent !== parent){
      this.newAge.childs.push(-1);
      this.childClass.push("");
      this.newAge.parent = parent;
      this.parentStatement = this.questions[this.newAge.parent - 1].Qn_In + " "+this.questions[this.newAge.parent - 1].Qn;
      if(!this.ageQuestions){
        this.ageQuestions = [];
      }
      if(this.questions[parent - 1].Parent_Repeat){
        let i = parent;
        while( i < this.questions.length && this.questions[i].Parent_Repeat === this.questions[parent-1].Parent_Repeat){
          this.ageQuestions.push(this.questions[i]);
          i++;
        }
      }else{
        for(let i=parent;i<this.questions.length;i++){
          this.ageQuestions.push(this.questions[i]);
        }
      }
    }
  }

  highPressInitial(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  highKeyup(event: any){

    if(event.target.value.charAt(event.target.value.length-1) === " "){
      event.target.value = event.target.value.substring(0,event.target.value.length - 1);
    }
  }

  highEntered(event : any){

      if(event.target.value > 0)
        this.newAge.high = parseInt(event.target.value);
      else
        this.newAge.high = null;
  }

  lowPressInitial(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  lowKeyup(event: any){

    if(event.target.value.charAt(event.target.value.length-1) === " "){
      event.target.value = event.target.value.substring(0,event.target.value.length - 1);
    }
  }

  lowEntered(event : any){
      if(event.target.value > 0)
        this.newAge.low = parseInt(event.target.value);
      else
        this.newAge.low = null;
  }

  childAdded(question_number : number,child  : number){
    this.newAge.childs[child] = question_number;
    this.childClass.push("");
  }

  removeChild(index : number){
    if(this.newAge.childs.length === 1){
      this.newAge.childs[0] = -1;
    }else{
      this.newAge.childs.splice(index,1);
      this.childClass.pop();
    }
  }

  addQuestion(){
    if(this.newAge.parent){
      this.newAge.childs.push(-1);
    }
  }

  close(){
        return null;
  }

  save(){

    if(!this.newAge.parent){
      this.parent = "red";
      this.addToast(true,false,false,false);
      return;
    }else{
      this.parent = "";
    }

    if(this.newAge.high === null || this.newAge.low === null){
      this.ageRange = "red";
      this.addToast(false,true,false,false);
      return;
    }else{
      this.ageRange = "";
    }

    if(this.newAge.low > this.newAge.high){
      this.ageRange = "red";
      this.addToast(false,false,true,false);
      return;
    }else{
      this.ageRange = "";
    }
    let found : boolean = false;
    for(let i=0;i<this.newAge.childs.length;i++){
      if(this.newAge.childs[i] === -1){
        found = true;
        this.childClass[i] = "red";
      }else{
        this.childClass[i] = "false";
      }
    }
    if(found){
      this.addToast(false,false,false,true);
      return;
    }

    if(!found){
      this.newAge.key = this.newAge.parent + "-" + this.newAge.low + "-" + this.newAge.high;
     this.dialogRef.close(this.newAge);
    }
  }





  addToast(noParent : boolean, noHighLow : boolean, wrongHighLow : boolean, child : boolean) {


    if(noParent){

      var toastOptions:ToastOptions = {
        title: "Empty Field",
        msg: "Select the question which gives age",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    }else if(noHighLow){

      var toastOptions:ToastOptions = {
        title: "Empty Field",
        msg: "Specify the age range",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    }else if(wrongHighLow){

      var toastOptions:ToastOptions = {
        title: "Empty Field",
        msg: "Make sure value in Age range first field is less than equal to second field",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    }else if(child){

      var toastOptions:ToastOptions = {
        title: "Empty Field",
        msg: "Specify which question to show",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/editAgeDialog/edit-age-dialog.component.ts